<p-toast></p-toast>
<app-nav-menu></app-nav-menu>
@if (loader) {
  <div style="width: 100%; height: 105vh; position: fixed; background: #e8e8e8de; z-index: 500;top:0 ">
    <div class="text-center" style="width: 100%; display: flex; justify-content: center; align-items: center; text-align: center; height: 100%; }">
      <div class="spinner">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
}
<div style="display:flex;flex-direction:column;">
  <div style="width: 100%; height: 50px; background-color: var(--first-color-second); color: white; display: flex; justify-content: center; align-items: center; letter-spacing: 2px">
    <h4>Offline Supplier</h4>
  </div>
  <div style="display: flex; justify-content: center; width: 100%; height:0">
    <div class="Triangle">

    </div>
  </div>

</div>

<div class="offlineSupplierContainer">

  <form #roeForm="ngForm" (submit)="SubmitData(roeForm)" class="offlineSupplierForm">


    <div>
      <div class="row justify-content-center form-section-title" style="color:var(--first-color-second);font-size:20px;letter-spacing:2px;text-decoration:underline;font-weight:bold;"> Offline Supplier </div>

      <div class="loop_div">
        <div class="row m-0 pt-2">
          <div class="col-md-3 col-sm-6 mb-4 form-field-col" style="position: relative;">
            <label id="namelabel" class="labelofmodifyserachinputs">
              Offline Supplier Name
            </label>
            <input type="text" [(ngModel)]="offlineSuppliersDetails.offlineSupplierName" [ngClass]="{'invalid-Error': formSubmit && !offlineSuppliersDetails.offlineSupplierName}"
              class="inputStyle" required autocomplete="off"
              name="OfflineSupplierName" />

              @if (formSubmit && !offlineSuppliersDetails.offlineSupplierName) {
                <span class="inputErrors">
                  **Supplier Name Required!
                </span>
              }
            </div>
            <!--<div class="col-md-3 col-sm-6 mb-4" style="position: relative;">
            <label id="Supplierlabel" class="labelofmodifyserachinputs">
              Supplier
            </label>
            <input type="text" class="inputStyle" [(ngModel)]="offlineSuppliersDetails.offlineSupplierCode" required autocomplete="off" [ngClass]="{'invalid-Error': formSubmit && !rateOfExchangeDetails.byDefaultROE}"
              name="Supplier" />
              <span class="inputErrors" *ngIf="formSubmit && !offlineSuppliersDetails.offlineSupplierCode">
                **Supplier Code Required!
              </span>
            </div>-->
            <div class="col-md-3 col-sm-6 mb-4 form-field-col" style="position: relative;">

              <label id="RoeRateByDefaultlabel" class="labelofmodifyserachinputs">
                Offline Provider Code
              </label>
              <input type="text" class="inputStyle" [(ngModel)]="offlineSuppliersDetails.offlineProviderCode" required autocomplete="off" [ngClass]="{'invalid-Error': formSubmit && !offlineSuppliersDetails.offlineProviderCode}"
                name="OfflineProviderCode" />

                @if (formSubmit && !offlineSuppliersDetails.offlineProviderCode) {
                  <span class="inputErrors">
                    **Provider Code Required!
                  </span>
                }
              </div>

              <div class="col-md-3 col-sm-6 mb-4 form-field-col form-toggle-col d-flex align-items-center">
                <div class="status-toggle-wrapper">
                  <label class="toggle-status-label">Active Status:</label>
                  <p-toggleswitch [(ngModel)]="offlineSuppliersDetails.isActive" name="isActive"></p-toggleswitch>
                </div>
              </div>

            </div>
          </div>

        </div>
        <hr class="dashed">

        <div style="border-radius: 8px;">

          <div class="row justify-content-center form-section-title" style="color:var(--first-color-second);font-size:20px;letter-spacing:2px;text-decoration:underline;font-weight:bold;"> Offline supplier Office </div>
          <div class="row m-0 justify-content-end pr-4 add-office-btn-row">
            <button type="button" class="addnewbtn" (click)="AddSupplierOffice()">
              <i class="fas fa-plus-circle"></i> Offline supplier Office
            </button>

          </div>
          <div class=" mt-4" >
            @for (data of offlineSupplierPccDetails; track data; let a = $index) {
              <div class="flightsdetails mt-4" >
                <div class="row m-0 align-items-center justify-content-between office-header-row">
                  <div class="col-8 col-md-6 p-0">
                    <label class="mb-0"><span style="font-weight:bold;">Offline supplier Office:</span> {{a + 1}}</label>
                  </div>
                  <div class="col-4 col-md-6 p-0">
                    <div class="row justify-content-end m-0">
                      <a class="card_button-delete" (click)="deleteairline(a)">
                        <i class="uil uil-trash-alt card_button-del"></i>
                      </a>
                    </div>
                  </div>
                </div>
                <div class="row m-0 mt-4 office-fields-row">
                  <div class="col-md-3 col-sm-6 mb-4 form-field-col office-col" style="position: relative;">
                    <label id="namelabel" class="labelofmodifyserachinputs">
                      Offline Pcc
                    </label>
                    <input type="text" class="inputStyle" required [(ngModel)]="data.offlinePcc" autocomplete="off" [ngClass]="{'invalid-Error': formSubmit && !data.offlinePcc}"
                      name="Offline Pcc{{a}}" />
                      @if (formSubmit && data.offlinePcc.length==0) {
                        <span class=" inputErrors">
                          **OfflinePCC Required!
                        </span>
                      }
                    </div>
                    <div class="col-md-3 col-sm-6 mb-4 form-field-col office-col" style="position: relative;">
                      <label id="OfficeIDlabel" class="labelofmodifyserachinputs">
                        Back Office Company
                      </label>
                      <p-select class="segmentDropdown" [options]="companyMasterList" [required]="true" name="backOfficeCompany{{a}}"
                        (onChange)="GetBackSystemSupplier(a)"
                        [(ngModel)]="data.backOfficeCompany" [ngClass]="{'p-dropdown invalid_Prime_Error': formSubmit && !data.backOfficeCompany}"
                      placeholder="Select BackOffice Company" optionLabel="companyName" optionValue="companyId"></p-select>
                      @if (formSubmit && data.backOfficeCompany.length==0) {
                        <span class=" inputErrors">
                          **BackOffice Company Required!
                        </span>
                      }
                    </div>
                    <div class="col-md-3 col-sm-6 mb-4 form-field-col office-col" style="position: relative;">
                      <label class="labelofmodifyserachinputs">
                        Back Office Supplier
                      </label>
                      <p-select class="segmentDropdown" [options]="data.supplierCodesList" [required]="true" name="backOfficeSupplier{{a}}"
                        [(ngModel)]="data.backOfficeSupplier" [ngClass]="{'p-dropdown invalid_Prime_Error': formSubmit && !data.backOfficeSupplier}"
                      placeholder="Select BackOffice Supplier" optionLabel="supplierName" optionValue="supplierCode"></p-select>
                      @if (formSubmit && data.backOfficeSupplier.length==0) {
                        <span class=" inputErrors">
                          **BackOffice Supplier Required!
                        </span>
                      }
                    </div>
                    <div class="col-md-2 col-sm-6 mb-4 form-field-col office-col currency-col" style="position: relative;">
                      <label id="OfficeIDlabel" class="labelofmodifyserachinputs">
                        Currency
                      </label>
                      <p-select class="segmentDropdown" [options]="suppliersCurrencyList" [required]="true" name="currency{{a}}"
                        [(ngModel)]="data.currency" [ngClass]="{'p-dropdown invalid_Prime_Error': formSubmit && !data.currency}"
                      placeholder="Select Currency" optionLabel="supplierCurrencyName" optionValue="supplierCurrencyName"></p-select>
                      @if (formSubmit && data.currency.length==0) {
                        <span class=" inputErrors">
                          **Currency Required!
                        </span>
                      }
                    </div>
                    <div class="col-md-1 col-sm-6 mb-4 form-field-col office-col office-toggle-col d-flex align-items-center">
                      <div class="status-toggle-wrapper">
                        <label class="toggle-status-label">Active:</label>
                        <p-toggleswitch [(ngModel)]="data.isActive" name="isActiveOffice{{a}}"></p-toggleswitch>
                      </div>
                    </div>
                  </div>
                </div>
              }
            </div>



          </div>



          <div class="row m-0 mt-4 mr-2 form-action-buttons">

            <button class="button-iMAGE mr-2" type="submit" id="btnSave">{{namebutton}}</button>

          <!--</div>
          <div class="col-sm-2">-->
            <button class="cancel_buttons" type="button" id="btnCancel" [routerLink]="['/offlineSupplierList']">Cancel</button>

          </div>
        </form>





      </div>
